//@flow
import React from 'react';
import { ActionButton } from 'components/atoms/button';
import IconDownArrowWhite from 'assets/images/downArrowWhite.png';
import IconDownArrowBlack from 'assets/images/downArrowBlack.png';
//eslint-disable-next-lone
import styles from './style.scss';

type Props = {
  theme?: string,
  onClick?: void,
  sectionName: string,
};

export const FooterExploreButton = (props: Props) => {
  const { theme, onClick, sectionName } = props;

  const arrowIcon =
    theme === 'dark-theme' ? IconDownArrowWhite : IconDownArrowBlack;

  return (
    <div className={'section-footer'}>
      <a
        className={'explore-btn'}
        href={`#${sectionName}`}
        style={{ textDecoration: 'none' }}
        // onClick={onClick}
      >
        <ActionButton
          className={'explore-btn'}
          buttonName={'EXPLORE'}
          iconLeft={IconDownArrowWhite}
        />
      </a>
    </div>
  );
};
